import { DataService } from './DataService';
import { MockDataService } from './MockDataService';
import { ApiDataService } from './api/ApiDataService';

// Check if we're in mock mode
const useMockApi = process.env.REACT_APP_USE_MOCK_API === 'true';

export class DataServiceFactory {
  private static instance: DataService;

  public static getService(): DataService {
    if (!this.instance) {
      if (useMockApi) {
        console.log('DataServiceFactory: Using MockDataService');
        this.instance = new MockDataService();
      } else {
        console.log('DataServiceFactory: Using ApiDataService');
        this.instance = new ApiDataService();
      }
    }
    
    return this.instance;
  }
}